import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import CorporateEventsPage from "@/pages/CorporateEventsPage";
import AboutPage from "@/pages/AboutPage";
import PrivacyPolicyPage from "@/components/PrivacyPolicyPage";
import AdminPage from "@/pages/AdminPage";
import AdminResetPasswordPage from "@/pages/AdminResetPasswordPage";
import InfluencerFormPage from "@/pages/InfluencerFormPage";
import ScrollToTop from "@/components/ScrollToTop";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const AppRoutes = () => {
  useEffect(() => {
    document.title = 'Persona Agency';
  }, []);

  useEffect(() => {
    const oldLinks = document.querySelectorAll('link[rel*="icon"]');
    oldLinks.forEach(link => link.remove());

    const iconSizes = ['16x16', '32x32', '64x64'];
    iconSizes.forEach(size => {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      link.sizes = size;
      link.href = `/favicon.png?v=${Date.now()}`;
      document.head.appendChild(link);
    });

    const shortcutIcon = document.createElement('link');
    shortcutIcon.rel = 'shortcut icon';
    shortcutIcon.href = `/favicon.png?v=${Date.now()}`;
    document.head.appendChild(shortcutIcon);
  }, []);

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/corporate-events" element={<CorporateEventsPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/adminboraorkun" element={<AdminPage />} />
      <Route path="/admin-reset-password" element={<AdminResetPasswordPage />} />
      <Route path="/influencer-registration" element={<InfluencerFormPage />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
